import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import checkCnicAndMobile from "./SwalHelper";
import Navbar from "../Navbar/navbar";
import Admin from "../Admin/Admin";
import PDF from "../pdfform/Pdf";
import MainForm from "./MainForm/MainForm";

function Landing() {
  const navigate = useNavigate();
 const [current, setCurrent] = useState(0);
// const [news, setNews] = useState([
//   "📢 The last date for submission of the Scholarship Form has been extended till 31st August 2025.",
//   " اسکالرشپ فارم جمع کروانے کی آخری تاریخ 31 اگست 2025 تک بڑھا دی گئی ہے۔📢",
//   " اسڪالرشپ فارم جمع ڪرائڻ جي آخري تاريخ 31 آگسٽ 2025 تائين وڌائي وئي آهي۔📢"
// ]);

 const newsItems = [
   {
     lang: "ur",
     text: " اسکالرشپ فارم جمع کروانے کی آخری تاریخ 31 اگست 2025 تک بڑھا دی گئی ہے۔ 📢",
    },
    {
      lang: "en",
      
      text: "📢 The last date for submission of the Scholarship Form has been extended till 31st August 2025.",
    },
    {
      lang: "sd",
      text: " اسڪالرشپ فارم جمع ڪرائڻ جي آخري تاريخ 31 آگسٽ 2025 تائين وڌائي وئي آهي۔ 📢",
    },
  ];

  // const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  // const [isLtr, setIsLtr] = useState(false);

  // // Cycle through news items and change text after specific time
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentNewsIndex((prevIndex) => (prevIndex + 1) % news.length);
  //   }, currentNewsIndex === 0 ? 15000 : 15000); // Adjust duration: 38s for English, 20s for Urdu

  //   return () => clearInterval(interval);
  // }, [currentNewsIndex]);

  // // Determine text direction (RTL for Urdu, LTR for English)
  // useEffect(() => {
  //   const currentNews = news[currentNewsIndex];
  //   const isUrdu = /[\u0600-\u06FF]/.test(currentNews); // Check for Urdu characters
  //   setIsLtr(isUrdu);
  // }, [currentNewsIndex, news]);

 useEffect(() => {
    const isLast = current === newsItems.length - 1;
    const delay = isLast ? 15000 : 15000; // Wait 15s after last message, 10s for others

    const timer = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % newsItems.length);
    }, delay);

    return () => clearTimeout(timer);
  }, [current]);

  const currentItem = newsItems[current];

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "Affidavit.pdf";
    link.download = "Sample-Affidavit-PDF";
    link.target = "_blank";
    link.rel = "noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleApply = () => {
    navigate("/form");
  };

  const openPopupWithPdf = (pdfUrl) => {
    const popup = window.open(
      "",
      "_blank",
      "width=800,height=600,top=100,left=100,resizable=yes"
    );

    popup.document.write(`
      <html>
        <head>
          <title>PDF Preview</title>
          <style>
            body { margin: 0; }
            iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
          </style>
        </head>
        <body>
          <iframe src="${pdfUrl}" frameborder="0"></iframe>
        </body>
      </html>
    `);
  };

const openPopupWithImage = (imageUrl, title = "Schedule") => {
  const popup = window.open(
    "",
    "_blank",
    "width=900,height=700,top=100,left=100,resizable=yes"
  );

  popup.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          body {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f3f3f3;
          }
          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        </style>
      </head>
      <body>
        <img src="${imageUrl}" alt="Schedule Image" />
      </body>
    </html>
  `);
};


  const handleView = () => {
    openPopupWithPdf("/Interview Schedule Committee No.II_Updated_08 January, 2025(1).pdf");
  };

  const handleList = () => {
    openPopupWithPdf("/interview list 2024.pdf");
  };

  const handleRevisedSchedule = () => {
    openPopupWithPdf("/revised-interview-schedule.pdf");
  };

  const handleUploadResult = async () => {
    try {
      const data = await checkCnicAndMobile();
      console.log("Data:", data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleCheckCnic = () => {
    Swal.fire({
      title: "Check CNIC and Mobile Number",
      html: `
        <input type="text" id="cnic" class="swal2-input" placeholder="CNIC (e.g. 12345-6789123-4)">
        <input type="text" id="mobile" class="swal2-input" placeholder="Mobile Number (e.g. 0300-1234567)">
      `,
      showCancelButton: true,
      confirmButtonText: "Verify",
      cancelButtonText: "Cancel",
      preConfirm: () => {
        const cnic = document.getElementById("cnic").value;
        const mobile = document.getElementById("mobile").value;
        const cnicPattern = /^\d{5}-\d{7}-\d$/;
        const mobilePattern = /^\d{4}-\d{7}$/;

        if (!cnicPattern.test(cnic) || !mobilePattern.test(mobile)) {
          Swal.showValidationMessage("Invalid CNIC or Mobile Number format");
          return;
        }

        return { cnic, mobile };
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        const { cnic, mobile } = result.value;
        axios
          .post("http://localhost:8000/api/check-cnic-and-mobile", {
            cnic,
            mobile,
          })
          .then((res) => {
            if (res.data.data) {
              const fetchedData = res.data.data;
              Swal.fire({
                title: "CNIC and Mobile Number Verified",
                text: `The entered CNIC and Mobile Number combination exists in the database with ID: ${fetchedData.id}`,
                icon: "success",
                confirmButtonText: "OK",
              });
            } else {
              Swal.fire({
                title: "CNIC and Mobile Number Not Found",
                text: "The entered CNIC and Mobile Number combination does not exist in the database",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch((err) => {
            console.log(
              "An error occurred while checking the CNIC and Mobile Number:",
              err
            );
          });
      }
    });
  };

  const handleTutorial = () => {
    const videoUrl = "https://www.youtube.com/watch?v=uGfmaTNa2qM";
    const windowFeatures =
      "width=800,height=600,top=100,left=100,resizable=yes";
    window.open(videoUrl, "_blank", windowFeatures);
  };

 return (
  <>
    <div className="min-h-screen w-full flex flex-col items-center p-4 bg-gray-100">
      {/* Header */}
      <header className="flex flex-col lg:flex-row justify-between items-center mb-4 w-full max-w-6xl px-4">
        <div className="w-20 mb-3 lg:mb-0 lg:mr-6 flex-shrink-0">
          <img src="/logo.png" alt="Logo" className="w-full h-auto" />
        </div>
        <div className=" mt-4 text-center">
          <h2 className="font-bold text-lg sm:text-xl md:text-2xl mb-1">GOVERNMENT OF SINDH</h2>
          <p className="text-xs sm:text-sm md:text-lg">COLLEGE EDUCATION DEPARTMENT</p>
          <p className="text-xs sm:text-sm md:text-lg">SINDH EDUCATIONAL ENDOWMENT FUND</p>
          <p className="text-xs sm:text-sm md:text-lg">REGISTERED VIDE TRUST DEED NO. 625/2020</p>
        </div>
      </header>
{/* News Strip */}

 {/* <div className="w-full h-10 overflow-hidden bg-yellow-100 flex items-center relative">
      <div
        dir={currentItem.direction}
        className={`absolute whitespace-nowrap text-lg font-medium   
          ${currentItem.lang === "en" ? "animate-marquee-rtl" : "animate-marquee-ltr"}`}
      >
        {currentItem.text}
      </div>
    </div>
   <div className="my-4 transition-transform duration-300 hover:scale-250">
  <img
    src="/news-icon.jpeg"
    alt="News Icon"
    className="h-48 w-auto object-contain rounded-lg shadow-md border border-gray-300"
  />
</div> */}
      {/* Welcome Heading */}
      <h1 className="text-center text-base sm:text-lg md:text-3xl font-bold mb-6 text-blue-800 px-4 leading-tight">
        Welcome To <br /> Sindh Educational Endowment Fund <br /> Scholarship Program
      </h1>

      {/* Main Content Section */}
      <div className="flex flex-col lg:flex-row w-full max-w-6xl items-start justify-center px-4 gap-6">
        <div className="w-full lg:w-5/12 p-6 sm:p-6 bg-gray-300 rounded-lg shadow-lg">

          {/* Buttons */}
          <div className="space-y-4">
          
            {/* <button
              onClick={handleApply}
              className="w-full py-3 text-sm sm:text-base bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-300 ease-in-out"
            >
              Apply for Scholarship
            </button> */}
            <button
              onClick={handleDownload}
              className="w-full py-3 text-sm sm:text-base bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-300 ease-in-out"
            >
              Download Sample Affidavit
            </button>

            {/* PDF Component */}
            <PDF />

            {/* <button
  onClick={() => openPopupWithPdf("/Interviews date all universities 2024-25.pdf")}
  className="w-full py-3 text-sm sm:text-base bg-green-500 text-white rounded hover:bg-green-600 transition duration-300 ease-in-out"
>
  View Interview Schedule
</button>

<button
  onClick={() =>
    openPopupWithImage("/schedule1.jpeg", "Interview Schedule 1")
  }
  className="w-full py-3 px-4 text-sm sm:text-base bg-purple-500 text-white rounded hover:bg-purple-600 transition duration-300 ease-in-out text-center"
>
  <span className="block font-medium">
    View Interview Schedule
  </span>
  <span className="block text-xs sm:text-sm opacity-90">
    (Liaquat National Hospital and Medical College)
  </span>
</button>


<button
  onClick={() =>
    openPopupWithImage("/schedule2.jpeg", "Interview Schedule 1")
  }
  className="w-full py-3 px-4 text-sm sm:text-base bg-purple-500 text-white rounded hover:bg-purple-600 transition duration-300 ease-in-out text-center"
>
  <span className="block font-medium">
    View Interview Schedule
  </span>
  <span className="block text-xs sm:text-sm opacity-90">
    (School of Law, University of karachi)
  </span>
</button>

<button
  onClick={() => openPopupWithPdf("/Interview  2024-25.pdf")}
  className="w-full py-3 text-sm sm:text-base bg-blue-500 text-white rounded hover:bg-blue-900 transition duration-300 ease-in-out"
>
  View Medical Universities Interview Schedule
</button>


<button
  onClick={() => openPopupWithPdf("/amn_add.pdf")}
  className="w-full py-3 text-sm sm:text-base bg-blue-500 text-white rounded hover:bg-blue-900 transition duration-300 ease-in-out"
>
  PEEF Scholarship Program 2025-26
</button> */}

          </div>

          {/* Contact Section */}
          {/* <div className="mt-2 border-t pt-6">
            <h2 className="text-center font-bold text-lg sm:text-xl underline mb-4">Contact Us:</h2>
            <p className="text-center text-sm sm:text-base md:text-lg font-medium leading-relaxed">
              For any queries, please contact:
              <br />
              <span className="underline text-blue-800">Mr. Usman Ali Mangrio</span>
              <br />
              <a
  href="https://wa.me/923452132045"
  target="_blank"
  rel="noopener noreferrer"
  className="underline text-green-700 hover:text-green-600 transition-colors duration-300"
  aria-label="Chat with Mr. Usman Ali Mangrio on WhatsApp"
>
  Message on WhatsApp: 0345-2132045
</a>

              
            </p>
          </div> */}
        </div>
      </div>
    </div>
  </>
);


}

export default Landing;
